import React, {useEffect, useState} from 'react';
import {MdMarkunread, MdReply, MdDelete} from "react-icons/all";
import parse from 'html-react-parser';
import {Container, Row, Col} from "react-bootstrap";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import moment from "moment";
import {useHistory, useParams} from "react-router-dom";
import {useAuth} from "../../../contexts/authContext";
import {getMessageDetails, hideRecipient, hideSender, setNotificationNotRead} from "../../../services/notifications";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';

// CSS Files
import './styles.css';

const NotificationDetails = (props) => {
   const [notification, setNotification] = useState(null);
   const history = useHistory();
   const auth = useAuth();
   const { t } = useTranslation();
   let { id } = useParams();

   useEffect(() => {
      (async () => {
         let notification = await getMessageDetails(id);
         setNotification(notification);
      })();
   }, []);

   if (!notification)
      return null;

   return <div className={"NotificationDetails"}>
      <Header className="header-height" headerBarTitle="&nbsp;&nbsp;&nbsp;"/>
      <Container className={"desktop"}>
         <Row>
            <Col xs={12}>
               <h6 className={"date"}>{moment(notification.date).utc().format('DD/MM/YYYY')}</h6>
               <h6 className={"sender-name"}>{notification.sender?.name}</h6>
               <h1>{notification.title}</h1>
               <hr/>
               {notification.body &&
                   parse(notification.body, {
                      replace: function (domNode) {
                         if (domNode.type === "tag" && domNode.name === 'a' && domNode.attribs.href) {
                            let url = new URL(domNode.attribs.href);
                            if (["padelbox.appx.pt", "app.padelbox.pt", "localhost", "padelbox-staging.herokuapp.com"].includes(url.host)) {
                               return <a href={url.href + url.search}>{domNode.children[0].data}</a>;
                            }
                         }
                      }
                   })}
               <hr/>
            </Col>

         </Row>
         <Row className={"pb-3"}>
            <Col xs={12}>
               <div className={"d-flex"}>
                  {notification.sender && notification.sender.id !== auth.user.id &&
                      <OverlayTrigger
                          placement={'bottom'}
                          delay={{show: 250, hide: 400}}
                          overlay={
                             <Tooltip id="button-tooltip">
                                {t("notification_page.reply")}
                             </Tooltip>
                          }
                      >
                         <MdReply
                             size={32}
                             onClick={() => history.push('/notifications/new', {recipients: [notification.sender.email]})}
                             className={"icon"}
                         />
                      </OverlayTrigger>
                  }

                  {notification.sender?.id !== auth.user.id &&
                      <OverlayTrigger
                          placement={'bottom'}
                          delay={{show: 250, hide: 400}}
                          overlay={
                             <Tooltip id="button-tooltip">
                                {t("notification_page.set_as_not_read")}
                             </Tooltip>
                          }
                      >
                         <div className={"unread-icon-container"}>
                            <MdMarkunread
                                size={32}
                                onClick={async () => {
                                   await setNotificationNotRead(id);
                                   history.push("/notifications");
                                }}
                                className={"icon"}
                            />
                         </div>
                      </OverlayTrigger>
                  }

                  <OverlayTrigger
                      placement={'bottom'}
                      delay={{show: 250, hide: 400}}
                      overlay={
                         <Tooltip id="button-tooltip">
                            {t("notification_page.delete")}
                         </Tooltip>
                      }
                  >
                     <MdDelete
                         size={32}
                         onClick={async () => {
                            if (notification.sender?.id === auth.user.id) {
                               await hideSender(id);
                            } else {
                               await hideRecipient(id);
                            }

                            switch (history.location.state.from) {
                               case '/notifications':
                                  history.push("/notifications");
                                  break;
                               case '/notifications/sent':
                                  history.push("/notifications/sent");
                                  break;
                               default:
                                  history.push("/notifications");
                            }
                         }}
                         className={"icon"}
                     />
                  </OverlayTrigger>
               </div>
            </Col>
         </Row>
      </Container>
   </div>
}

export default NotificationDetails;
